<template>
    <div class="main-menu">
        <div class="container">
            <div class="gabarit">
                <div class="internal-navigation">
                    <nav class="main-nav">
                        <ul>
                            <li v-for="link in mainLinks">
                                <router-link
                                    :to="$trl({
                                        name: link.name,
                                        params: {
                                            locale: $route.params.locale
                                        }
                                    })"
                                    :class="['main-link', {mobile: link.mobile}]"
                                >
                                    <span class="helper">
                                        <span class="caption">{{link.caption}}</span>
                                        <span class="caption-red">{{link.caption}}</span>
                                    </span>
                                </router-link>
                            </li>
                        </ul>
                    </nav>
                    <footer class="main-foot">
                        <div class="left fade-helper decorated-top">
                            <ul class="links">
                                <li v-for="link in menu.column1">
                                    <Link
                                        :cta="link"
                                    />
                                </li>
                            </ul>
                            <ul class="links">
                                <li v-for="link in menu.column2">
                                    <Link
                                        :cta="link"
                                    />
                                </li>
                                <!-- <li>
                                    <router-link
                                        :to="$trl({
                                            name: 'Markets',
                                            params: {
                                                locale: $route.params.locale
                                            }
                                        })"
                                    >
                                        {{$t('nav.markets')}}
                                    </router-link>
                                </li>
                                <li>
                                    <router-link
                                        :to="$trl({
                                            name: 'Techniques',
                                            params: {
                                                locale: $route.params.locale
                                            }
                                        })"
                                    >
                                        {{$t('nav.techniques')}}
                                    </router-link>
                                </li>
                                <li>
                                    <router-link
                                        :to="$trl({
                                            name: 'Innovation',
                                            params: {
                                                locale: $route.params.locale
                                            }
                                        })"
                                    >
                                        {{$t('nav.innovation')}}
                                    </router-link>
                                </li> -->
                            </ul>
                            <ul class="links">
                                <li v-for="link in menu.column3">
                                    <Link
                                        :cta="link"
                                    />
                                </li>
                                <!-- <li>
                                    <router-link
                                        :to="{
                                            name: 'Legal',
                                            params: {
                                                locale: $route.params.locale
                                            }
                                        }"
                                    >
                                        {{$t('nav.legalnotices')}}
                                    </router-link>
                                </li>
                                <li>
                                    <router-link
                                        :to="{
                                            name: 'Privacy',
                                            params: {
                                                locale: $route.params.locale
                                            }
                                        }"
                                    >
                                        {{$t('nav.privacypolicy')}}
                                    </router-link>
                                </li>
                                <li>
                                    <router-link
                                        :to="{
                                            name: 'Termsofuse',
                                            params: {
                                                locale: $route.params.locale
                                            }
                                        }"
                                    >
                                        {{$t('nav.termsofuse')}}
                                    </router-link>
                                </li> -->
                            </ul>
                        </div>
                        <div class="right fade-helper decorated-top">
                            <span class="strong">
                                {{$t('nav.findus')}}
                            </span>
                            <div>
                                <a href="https://www.linkedin.com/company/soletanche-bachy/" class="link" target="_blank">
                                    <IconLinkedin class="logo linkedin"/>
                                </a>
                                <a href="https://www.youtube.com/channel/UCnWhof4dRavOkevAbECraag" class="link" target="_blank">
                                    <IconYoutube class="logo youtube"/>
                                </a>
                            </div>
                        </div>
                    </footer>
                </div>
                <div class="external-navigation">
                    <div class="experience-decoration">
                        <div class="image-grabber">
                            <div class="image-gabarit">
                                <div class="image-holder"/>
                            </div>
                        </div>
                        </div>
                    <strong class="title">
                        <SplitText :data="$t('cta.xp.title')" :animated="false"/>
                    </strong>
                    <div class="text-link fade-helper">
                        <p class="text">
                            {{$t('cta.xp.baseline')}}
                        </p>
                        <Cta
                            :type="'a'"
                            class="link"
                            href="https://experience.soletanche-bachy.com/"
                            target="_blank"
                            @click.native="openLocations()"
                        >
                            {{$t('cta.xp.explore')}}
                        </Cta>
                    </div>
                </div>
                <div class="background-decoration">
                    <div class="grid-helper"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import IconYoutube from '@/components/IconYoutube'
import IconLinkedin from '@/components/IconLinkedin'
import Cta from '@/components/Cta'
import Link from '@/components/Link'
import SplitText from '@/components/SplitText'

import {
    menu
} from '@/store/index.js'

export default {
    components: {
        Cta,
        Link,
        IconYoutube,
        IconLinkedin,
        SplitText
    },
    computed: {
        menu() {
            return menu.data
        },
        mainLinks() {
            return [
                {
                    name: 'About',
                    caption: this.$t('nav.about')
                },
                {
                    name: 'Solutions',
                    caption: this.$t('nav.solutions')
                },
                {
                    name: 'Projects',
                    caption: this.$t('nav.projects')
                },
                {
                    name: 'Contact',
                    caption: this.$t('nav.contact')
                },
                {
                    name: 'News',
                    caption: this.$t('nav.news'),
                    mobile: true
                },
                {
                    name: 'Joinus',
                    caption: this.$t('nav.joinus'),
                    mobile: true
                },
            ]
        }
    }
}
</script>
<style lang="sass" scoped>
@import "@/styles/vars.sass"
$leftSideWidth: 66.6665%
$rightSideWidth: (100% - $leftSideWidth)
$leftMargin: #{ 100% * (100% / $leftSideWidth) * 114px / 1920px }
$leftMarginBig: calc((100vw - 1920px) / 2 + #{ $leftMargin })
$rightMarginBig: calc((100vw - 1920px) / 2)
a
    text-decoration: none
.strong
    font-weight: 500
.main-menu
    position: fixed
    top: 0
    left: 0
    bottom: 0
    width: 100vw
    display: flex
    z-index: 10
    overflow: hidden
.container
    flex: 1
    display: flex
    overflow: auto
    // -webkit-overflow-scrolling: touch
    @include media-breakpoint-down($md)
        display: block
    @media (orientation: portrait)
        display: block
        height: 100%
.gabarit
    position: relative
    z-index: 1
    display: flex
    flex: 1
    overflow: hidden
    min-height: 700px
    @include media-breakpoint-down($md)
        flex-direction: column
    @media (orientation: portrait)
        flex-direction: column
.main-nav
    // font-size: 160px
    font-size: 8.3333333333vw
    // color: #ff2b2a
    line-height: 0.89375
    font-weight: 500
    letter-spacing: -0.03125em
    margin-top: auto
    margin-left: $leftMarginBig
    padding-bottom: (100% * 2.5% / $leftSideWidth)
    li
        margin-bottom: 0
        @include media-breakpoint-down($md)
            margin-bottom: .25em
        a
            line-height: 1.1
            margin-bottom: -.1em


    @include media-breakpoint-up($xxl)
        font-size: 160px
    @media (max-height: 1024 - 1px)
        font-size: 140px
    @include media-breakpoint-down(1650px)
        font-size: 140px
    @media (max-height: 950 - 1px)
        font-size: 120px
    @include media-breakpoint-down($xl)
        font-size: 120px
    @media (max-height: 850 - 1px)
        font-size: 100px
    @include media-breakpoint-down($hd)
        font-size: 100px
    @media (max-height: 768 - 1px)
        font-size: 86px
    @include media-breakpoint-down($lg)
        font-size: 86px
    @include media-breakpoint-down($md)
        padding-top: 80px
        margin-top: 76px
    @include media-breakpoint-down($sm)
        padding-top: 50px
        font-size: 70px
    @include media-breakpoint-down($xxl)
        margin-left: $leftMargin
    @media (orientation: portrait)
        padding-top: 80px
        margin-top: 8%
.background-decoration
    position: absolute
    left: 0
    top: 0
    width: 100%
    height: 100%
    z-index: -1
    background-color: #ffffff
    overflow: hidden
    transition: transform 1s cubic-bezier(.65,0,.25,1)

.grid-helper
    background-image: url('../assets/bg-cross-gradiant-red.png')
    background-position: center top
    background-repeat: repeat-x
    height: 100%

.main-foot
    display: flex
    margin-left: $leftMarginBig
    margin-right: (100% * 2.5% / $leftSideWidth)
    min-height: 200px
    color: #ff2b2a
    line-height: 2
    text-transform: capitalize
    @include media-breakpoint-down($md)
        flex-direction: column
    @include media-breakpoint-down($sm)
        .links
            li
                font-size: 14px
    @media (orientation: portrait)
        flex-direction: column
    &>.left
        display: flex
        flex: 1
        padding-top: 50px
        overflow: hidden
        @include media-breakpoint-down($md)
            flex-direction: column
            padding-bottom: 25px
            padding-top: 25px
        @media (orientation: portrait)
            padding-bottom: 25px
            padding-top: 25px
        .links
            flex: 1
    &>.right
        width: 23%
        margin-left: 11.7%
        padding-top: 50px
        margin-left: (100% * 5.9375% / $leftSideWidth)
        overflow: hidden
        @include media-breakpoint-down($md)
            padding-bottom: 25px
            padding-top: 25px
            margin-left: 0
            width: 100%
        @media (orientation: portrait)
            padding-bottom: 25px
            padding-top: 25px
            margin-left: 0
            width: 100%
    @include media-breakpoint-down($xxl)
        margin-left: $leftMargin
.decorated-top
    position: relative
    &:before
        content: ""
        display: block
        width: 100%
        height: 1px
        background-color: #ff2b2a
        position: absolute
        top: 0
        left: 0

.internal-navigation
    width: $leftSideWidth
    display: flex
    flex-direction: column
    @include media-breakpoint-down($md)
        width: 100%
    @media (orientation: portrait)
        width: 100%
        flex: 1
    .logo
        margin-top: 1.8em
        @include media-breakpoint-down($md)
            margin-top: 1em
        @media (orientation: portrait)
            margin-top: 1em
        /deep/ path
            fill: #b2becf
        &.linkedin
            width: 21px
            height: auto
        &.youtube
            width: 25px
            height: auto
            margin-left: 0.8em
    .link:hover
        .logo
            /deep/ path
                fill: #ff2b2a
.external-navigation
    z-index: 0
    width: $rightSideWidth
    display: flex
    flex-direction: column
    color: #114991
    background-size: auto 100%
    position: relative
    @include media-breakpoint-down($md)
        width: 100%
        padding-top: 160px
        padding-bottom: 50px
    @media (orientation: portrait)
        width: 100%
        padding-top: 200px
        padding-bottom: 50px
    @include media-breakpoint-down($sm)
        padding-top: 36px
        padding-bottom: 36px
    .title
        margin-top: auto
        margin-left: 12.2%
        padding-right: 8%
        padding-bottom: (100% * 2.5% / $rightSideWidth)
        color: #114991
        font-weight: 500
        font-size: 86px // 4.2vw
        letter-spacing: -0.03em
        transition: transform 1s cubic-bezier(.65,0,.25,1)
        @include media-breakpoint-up($hd)
            [lang="en"] &
                font-size: 4.2vw
        /deep/ .word
            @for $i from 1 through 3
                &[data-row="#{$i - 1}"]
                    // @if $i > 1
                    //     position: relative
                    //     top: -0.24375em
                    .caption
                        transition-delay: .1s * ($i - 1)
        @media (max-height: 850 - 1px)
            font-size: 70px
        @include media-breakpoint-down($hd)
            font-size: 70px
        // @include media-breakpoint-down($xxl)
        @include media-breakpoint-down($sm)
            margin-right: 0
            font-size: 40px
            padding-bottom: 0
        @media (orientation: portrait)
            margin-top: 0
            padding-bottom: 0
    .text-link
        height: 200px
        margin-right: $rightMarginBig
        margin-left: 12.2%
        transition: transform 1s cubic-bezier(.65,0,.25,1)
        @include media-breakpoint-down($xxl)
            margin-right: 0
        @include media-breakpoint-down($md)
            height: auto
        @media (orientation: portrait)
            height: auto
    .text
        margin-bottom: 50px
        font-weight: 500
        line-height: 1.4285714286
        @include media-breakpoint-down($sm)
            margin-bottom: 25px
            font-size: 14px

    // &:hover
    //     .experience-decoration
    //         transform: translateX(-160px)
    //         .image-grabber
    //             transform: translateX(0px)
    //     .title
    //         transform: translateX(-40px)
    //     .text-link
    //         transform: translateX(-40px)
    //     &~.background-decoration
    //         transform: translateX(-70px)

.experience-decoration
    position: absolute
    left: initial
    right: -160px
    top: 0
    box-sizing: content-box
    width: 100%
    height: 100%
    z-index: -1
    overflow: hidden
    margin-left: -160px
    padding-left: 160px
    transition: transform 1s cubic-bezier(.65,0,.25,1)
    // transform: translateX(160px)
    .image-grabber
        position: absolute
        left: 0
        top: 0
        width: 100%
        height: 100%
        overflow: hidden
        transform: translateX(-80px)
        transition: transform 1s cubic-bezier(.65,0,.25,1)
    .image-gabarit
        position: absolute
        left: 0
        top: 0
        width: 100%
        height: 100%
        overflow: hidden
    .image-holder
        background-image: url('../assets/img-menu.jpg')
        background-position: 50% 50%
        background-repeat: no-repeat
        background-size: cover
        height: 100%

li
    margin-bottom: .0625em
    // @media (orientation: portrait)
    @include media-breakpoint-down($md)
        margin-bottom: .625em

    @for $i from 1 through 4
        &:nth-child(#{$i})
            .helper
                transition-delay: .03s * ($i - 1)
ul
    &:hover
        .caption-red
            opacity: 0
        .caption
            opacity: 1
.main-link
    display: block
    overflow: hidden
    position: relative
    white-space: nowrap
    &.mobile
        display: none
        @include media-breakpoint-down($lg)
            display: block
    @include media-breakpoint-down($sm)
        white-space: nowrap
        font-size: 40px
        margin-bottom: 2.5%
    &:first-letter
        text-transform: capitalize
    .caption
        opacity: 0
    .caption-red
        color: #ff2b2a
        position: absolute
        left: 0
        top: 0
    .helper
        color: rgb(188,198, 214)
        display: block
    &:hover
        .caption
            opacity: 0
        .caption-red
            opacity: 1

.main-menu-enter-active
    transition: visibility 3.5s
    .background-decoration
        transition: transform 1.0s cubic-bezier(.65,0,.25,1)
    .grid-helper
        transition: transform 1.0s cubic-bezier(.65,0,.25,1)
    .external-navigation
        transition: transform 1s cubic-bezier(.65,0,.25,1) .25s
    .experience-decoration
        .image-gabarit
            transition: transform 1s cubic-bezier(.65,0,.25,1) .25s
        .image-holder
            transition: transform 3s .25s
    li
        @for $i from 1 through 4
            &:nth-child(#{$i})
                .main-link
                    .helper
                        transition-delay:  .725s + .03s * ($i - 1)
    .main-link
        .helper
            transition: transform 1.0s cubic-bezier(.65,0,.25,1) .725s
    .fade-helper
        transition: opacity 1.0s 1.2s, transform 1s cubic-bezier(.65,0,.25,1)
    .decorated-top
        &:before
            transition: transform .625s 1.2s
    .title
        /deep/ .word
            @for $i from 1 through 3
                &[data-row="#{$i - 1}"]
                    // @if $i > 1
                    //     position: relative
                    //     top: -0.24375em
                    .caption
                        transition-delay: .1s * ($i - 1) + .725s
            .caption
                transition: transform 1.0s cubic-bezier(.65,0,.25,1) .725s
.main-menu-enter
    .background-decoration
        transform: translateY(100%)
    .grid-helper
        transform: translateY(-40%)
    .external-navigation
        transform: translateY(100%)
    .experience-decoration
        .image-gabarit
            transform: translateY(-100%)
        .image-holder
            transform: scale(1.5)
    .main-link
        .helper
            transform: translateY(100%)
    .fade-helper
        opacity: 0
    .decorated-top
        &:before
            transform: translateX(-100%)
    .title
        /deep/ .word
            .caption
                transform: translateY(100%)

.main-menu-leave-active
    transition: transform 1.2s cubic-bezier(.65,0,.25,1)
    .container
        transition: transform 1.2s cubic-bezier(.65,0,.25,1)
    .background-decoration
        transition: transform 1.0s cubic-bezier(.65,0,.25,1)
    .grid-helper
        transition: transform 1.0s cubic-bezier(.65,0,.25,1)
    .external-navigation
        transition: transform .825s cubic-bezier(.65,0,.25,1) .5s
    .experience-decoration
        .image-holder
            transition: transform 1s
    .main-link
        .helper
            transition: transform .625s cubic-bezier(.65,0,.25,1)
    .fade-helper
        transition: opacity .3s,  transform 1s cubic-bezier(.65,0,.25,1)
    .title
        /deep/ .word
            .caption
                transition: transform .625s cubic-bezier(.65,0,.25,1)

    .experience-decoration
        transform: translateX(0px) !important
        .image-grabber
            transform: translateX(-80px) !important
    .title
        transform: translateX(0px) !important
    .text-link
        transform: translateX(0px) !important
.main-menu-leave-to
    transform: translateY(-100%)
    .container
        transform: translateY(100%)
    .experience-decoration
        .image-holder
            transform: scale(1.15)
    .grid-helper
        transform: translateY(-40%)
    .main-link
        .helper
            transform: translateY(-120%)
    .fade-helper
        opacity: 0
    .title
        /deep/ .word
            .caption
                transform: translateY(-100%)

</style>
